export function createTenantAnalyticsClient(transport) {
    return {
        /**
         * Record one governed analytical fact, or recognise one already recorded
         *
         * Requires scope: analytics:ingest
         */
        recordAnalyticsFact(tenantId, body, options) {
            return transport.request({
                method: "POST",
                path: `/internal/v1/tenants/${encodeURIComponent(tenantId)}/analytics-facts`,
                body,
                options,
            });
        },
        /**
         * Completed and cancelled volume over time, with gross value per currency
         *
         * Requires scope: analytics:read
         */
        getDemandAnalytics(tenantId, from, to, granularity, serviceType, zoneId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/analytics/demand`,
                query: {
                    from: from,
                    to: to,
                    granularity: granularity,
                    serviceType: serviceType,
                    zoneId: zoneId,
                },
                options,
            });
        },
        /**
         * Driver online and engaged time, offers, and distinct active drivers over time
         *
         * Requires scope: analytics:read
         */
        getSupplyAnalytics(tenantId, from, to, granularity, serviceType, zoneId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/analytics/supply`,
                query: {
                    from: from,
                    to: to,
                    granularity: granularity,
                    serviceType: serviceType,
                    zoneId: zoneId,
                },
                options,
            });
        },
        /**
         * Cancellations, SLA breaches, support cases and satisfaction over time
         *
         * Requires scope: analytics:read
         */
        getQualityAnalytics(tenantId, from, to, granularity, serviceType, zoneId, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/analytics/quality`,
                query: {
                    from: from,
                    to: to,
                    granularity: granularity,
                    serviceType: serviceType,
                    zoneId: zoneId,
                },
                options,
            });
        },
        /**
         * Customer cohorts by first month seen within the window, and their return
         *
         * Requires scope: analytics:read
         */
        getRetentionAnalytics(tenantId, from, to, options) {
            return transport.request({
                method: "GET",
                path: `/v1/tenants/${encodeURIComponent(tenantId)}/analytics/retention`,
                query: { from: from, to: to },
                options,
            });
        },
        /**
         * Product usage per tenant, across every tenant
         *
         * Requires scope: analytics:platform:read
         */
        listPlatformTenantUsage(from, to, options) {
            return transport.request({
                method: "GET",
                path: "/v1/platform/analytics/tenant-usage",
                query: { from: from, to: to },
                options,
            });
        },
        /**
         * Report this service's identity and declared implementation status
         */
        getServiceInfo(options) {
            return transport.request({
                method: "GET",
                path: "/v1/service-info",
                options,
            });
        },
    };
}
//# sourceMappingURL=tenant-analytics.js.map